import { Modal } from 'doraemon';

const MESSAGE_TYPE = 'INSTITUTION_CHANGE';
let currentInstitutionId = null;
let isMonitoring = false;
let intervalId = null;

let channel = '';

/**
 * 向所有打开的页面广播单位变更消息
 * @param {string} newInstitutionId 新的单位ID
 */
function broadcastInstitutionChange(newInstitutionId) {
  const message = {
    type: MESSAGE_TYPE,
    institutionId: newInstitutionId,
    timestamp: Date.now(),
    source: window.location.href,
  };

  // 方法3: 向同源的其他窗口发送消息
  try {
    channel.postMessage(message);
  } catch (error) {
    console.log('向窗口发送消息失败:', error);
  }
}

/**
 * 检查单位是否变更
 */
function checkInstitutionChange() {
  const windowInstitutionId = window.currentUserIdentity?.institutionId;
  if (windowInstitutionId && windowInstitutionId !== currentInstitutionId) {
    // 更新当前单位ID，保证当前页面单位ID与其他页面保持一致
    currentInstitutionId = windowInstitutionId;
    // 单位已变更，发送消息给所有打开的页面
    broadcastInstitutionChange(windowInstitutionId);
  }
}

/**
 * 开始监测单位变更
 */
function startMonitoring() {
  intervalId = setInterval(() => {
    checkInstitutionChange();
  }, 10000);
}

/**
 * 停止监测单位变更
 */
export function stopMonitoring() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }

  isMonitoring = false;
  currentInstitutionId = null;

  // 移除消息监听
  channel.removeEventListener('message', handleMessage);
}

/**
 * 显示单位变更提示弹窗
 */
function showInstitutionChangeModal() {
  stopMonitoring();
  Modal.confirm({
    title: '单位变更提醒',
    content: '检测到您的登录单位已变更，为保证系统正常运行，需要刷新页面以应用新的单位设置。',
    okCancel: false,
    okText: '刷新页面',
    onOk: () => {
      window.location.reload();
    },
  });
}

/**
 * 处理接收到的消息
 * @param {MessageEvent} event
 */
function handleMessage(event) {
  const { data } = event;
  if (data && data.type === MESSAGE_TYPE) {
    // 收到单位变更消息
    // 无当前单位ID时，直接赋值，不提示
    if (!currentInstitutionId) {
      currentInstitutionId = data.institutionId;
      return;
    }
    // 有单位ID且单位ID不同时，提示变更
    if (data.institutionId !== currentInstitutionId) {
      showInstitutionChangeModal();
      // 更新当前单位ID，保证当前页面单位ID与其他页面保持一致， 避免重复弹出弹窗
      currentInstitutionId = data.institutionId;
    }
  }
}

/**
 * 初始化单位变更监测
 */
export function initInstitutionMonitor() {
  if (isMonitoring) return;
  isMonitoring = true;
  // 1. 创建/连接广播频道（频道名自定义，同频道的窗口互通）
  channel = new BroadcastChannel('global-channel');
  // 开始监测单位变更
  startMonitoring();
  // 监听来自其他页面的消息
  channel.addEventListener('message', handleMessage);
}

/**
 * 获取当前监测的单位ID
 */
export function getCurrentInstitutionId() {
  return window.currentUserIdentity.institutionId;
}

/**
 * 手动触发单位变更检查（用于测试）
 */
export function triggerInstitutionCheck() {
  checkInstitutionChange();
}

// 4. 窗口关闭时关闭频道（避免内存泄漏）
window.addEventListener('unload', () => {
  channel?.close();
});
